export default "__VITE_ASSET__B8ilhs$3__"